import { SharedModalsVuex, SharedModalsVuexState } from "@/shared/vuex";
import { StoreOptions } from "vuex";

export interface TalentModalsVuexState extends SharedModalsVuexState {
  isBusinessOpen: boolean;
  isOpportunityOpen: boolean;
  isBiddingOpen: boolean;
  loading?: boolean;
}

export const TalentModalsVuex: StoreOptions<TalentModalsVuexState> = {
  ...{ namespaced: true },
  state: {
    ...(SharedModalsVuex.state as SharedModalsVuexState),
    isBusinessOpen: false,
    isOpportunityOpen: false,
    isBiddingOpen: false,
  },
  mutations: {
    ...SharedModalsVuex.mutations,
    /**
     *
     * @param state
     * @param status
     */
    business(state, status: boolean) {
      state.isBusinessOpen = status;
    },
    /**
     *
     * @param state
     * @param status
     */
    opportunity(state, status: boolean) {
      state.isOpportunityOpen = status;
    },
    /**
     *
     * @param state
     * @param status
     */
    bidding(state, status: boolean) {
      state.isBiddingOpen = status;
    },
  },
  actions: {
    ...SharedModalsVuex.actions,
  },
  modules: {},
  //
  getters: {
    ...SharedModalsVuex.getters,
  },
};
